// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2ut4C","colMaxWidth":"Table_colMaxWidth__1sOIU"};